module.exports = __webpack_public_path__ + "static/img/tabs4.a4c75fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs4.png
// module id = u2ci
// module chunks = 13